import(/* webpackMode: "eager" */ "/vercel/path0/src/app/doctors/page.tsx");
